<template>

  <div class="wrapper">
    <div class="bg bg1"></div>
    <div class="bg bg2"></div>
    <div class="content">
      <h2>Christmas Workshops for Groups or Teams</h2>
      <p>Looking for workshops for your team or a group of friends? Contact us at&nbsp;<a href="mailto:learn@hatopress.net?subject=Christmas+Group+Workshop">learn@hatopress.net</a> or find out what we're&nbsp;offering<br><br>
      <div class="action">
        <!-- <a href="mailto:learn@hatopress.net?subject=Christmas+Workshop" target="_blank" >Find out more</a> -->
        <router-link :to="{ name: 'Christmas' }">Find out more</router-link>
      </div>
    </div>

  </div>

</template>

<script>

export default {
  data () {
    return {
      cardImage: require('../assets/gift-compressed.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  text-align: center;
  /* background: #f3f3f3; */
  margin: 0 0;
  padding: 4rem 0 4rem;
  position: relative;
}

.content {
  max-width: 30em;
  margin: auto;
  background: white;
  padding: 1em 2em 3em;
  border: 1px solid #eee;
  position: relative;
  transform: translate3d(-20%,10%,0);
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.2);
  transition: .1s ease all;
}

.action a {
  display: inline-block;
  /*font-size: .8em;*/
  margin: 0 1em;
  padding: .6em 1.5em;
  /*border: 1px solid;*/
  border-radius: 8px;
  border-radius: 5px;
  background: hsl(36, 72%, 71%);
}
.action a:hover {
  background: hsl(36, 72%, 61%);
}

.bg {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50%;
  width: 30em;
  height: 19em;
  margin: auto;
  background-size: cover;
}
.bg1 {
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.2);
  background-image: url('https://assets.hato.co/b1/assets/workshops/HatoPress-Risograph-Workshop-Christmas-(Riso-Machine)-2400-0441.jpg');
  transform: translate3d(20%,-10%,0);
  transition: .1s ease all;
}
.bg2 {
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.2);
  background-image: url('https://assets.hato.co/b1/assets/workshops/HatoPress-Risograph-Workshop-Christmas-(Wrapping-Paper)-2400-0491.jpg');
  transform: translate3d(0%,0%,0);
  transition: .1s ease all;
}

.content:hover {
  transform: translate3d(-20%,10%,0) rotate(2deg);
}
.bg1:hover {
  transform: translate3d(50%,-20%,0) rotate(2deg);
}
.bg2:hover {
  transform: translate3d(30%,-10%,0) rotate(2deg);
}



@media screen and (max-width: 768px) {
  .content {
    max-width: 85%;
    transform: translate3d(-10px,10px,0);
  }
  .bg1 {
    max-width: 85%;
    height: 20em;
    transform: translate3d(10px,-10px,0);
  }
  .bg2 {
    max-width: 85%;
    height: 20em;
    transform: translate3d(0,0,0);
  }
  .content:hover {
    transform: translate3d(-10px,10px,0);
  }
  .bg1:hover {
    transform: translate3d(10px,-10px,0);
  }
  .bg2:hover {
    transform: translate3d(0,0,0);
  }
  .wrapper {
    padding: 2rem 0 2rem;
  }
}
@media screen and (max-width: 640px) {
  .wrapper {
    /*padding: 1rem;*/
    padding: 1rem auto 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// Christmas.vue?57b4badf